import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'commaReplacer'
})

export class CommaReplacerPipe implements PipeTransform {
    transform(value: string, args: any[]): string {
        if (value) {
          return value.replace(/,/g, '');
        }
        return '';
    }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/shared/comma-replacer.pipe.ts